import { Component, Input } from '@angular/core';
import { FAZILService, User } from 'src/app/core';
import { UIService } from 'src/app/core/services/ui.service';
import { DataAssistantListUX } from 'src/app/modelo/DataAssistantListUX';
import { DataAssistantUX } from 'src/app/modelo/DataAssistantUX';

import * as moment from 'moment';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-asistente',
    templateUrl: './asistente.component.html'})

export class AsistenteComponent {
    
    //Variables de configuración/mensajes
    appConfig = environment.settings;
    
    _currentUser: User;
    ui: UIService;
    
    _assistant: DataAssistantListUX = new DataAssistantListUX();
    itemAssistant: DataAssistantUX = new DataAssistantUX();
    
    mostrarPlanPopup: boolean = false;
    
    constructor(
        private fazilService: FAZILService,
        private uiService: UIService,
    ){
        this.ui = uiService;
        moment.locale('es');
    }
    
    @Input()
    set assistant(assistant: DataAssistantListUX) {
        this._assistant = assistant
    }

    get assistant() { return this._assistant; }
    
    @Input()
    set currentUser(currentUser: User) {
        this._currentUser = currentUser
    }

    get currentUser() { return this._currentUser; }

    irAInicio(){
        this.fazilService.irAFactura();
    }
    
    
    irAAssistentOpcion(event) {
        if (event && event.option) {
            switch (event.option['key']) {
                case 'ruc':
                    this.fazilService.irAInformacionSRI();
                    break;
                case 'producto':
                    this.fazilService.irAProductosServicios();
                    break;
                case 'contacto':
                    this.fazilService.irAContactos();
                    break;
                case 'plan':
                    this.cargarPlan(event);
                    break;
                case 'certificado_digital':
                    this.fazilService.irARegistrarCertificadoDigital();
                    break;
                case 'acepta_terminos_condiciones':
                    this.fazilService.irAAceptarTerminosCondiciones();
                    break;
                default:
                    break;
            }
        }
    }

    
    cargarPlan(event) {
        this.mostrarPlanPopup = true;
    }
        
}
